import React from 'react'

function Nocall() {
    return (
        <div className='information'>
            <div className='messageContainer'>
                <h1 className='responseHeader'>You currently do not have a game selected.</h1>
                <p className='responseText'>Please select a game to view the call information.</p>
            </div>
        </div>
    )
}

export default Nocall
